"use client";
import React, { useEffect, useState } from "react";
import styles from "../AvailabilitySelectionModule.module.css";
import { roundSessionCount } from "@/utils/roundSessionCount";
import dayjs from "dayjs";
import Dollar from "@/components/icons/Dollar";
import Star from "@/components/icons/Star";
import { MentorCheckoutInfo } from "../AvailabilitySelectionModule.machine";

interface BookingInfoProps {
  mentor_info: MentorCheckoutInfo;
  duration: 30 | 60;
  price: number;
  toggleDuration: () => void;
}

const BookingInfo = ({
  mentor_info,
  duration,
  price,
  toggleDuration,
}: BookingInfoProps) => {
  const [current_time, setCurrentTime] = useState<string>("");

  // update the time each minute
  useEffect(() => {
    const updateTime = () => {
      const time = dayjs().format("h:mma");
      setCurrentTime(time);
    };
    updateTime();
    const interval_reference = setInterval(
      updateTime,
      60000 - dayjs().second() * 1000
    );
    return () => {
      clearInterval(interval_reference);
    };
  }, []);

  const getTZAbbr = (): string => {
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZoneName: "short",
    });
    const date_time = formatter.format(new Date());
    const time_zone_abbr = date_time.split(" ").pop();
    return time_zone_abbr || "";
  };

  return (
    <div className={styles.booking_info}>
      <h1 className={styles.info_title}>Book with {mentor_info.first_name}</h1>
      <p className={styles.info_timezone}>
        Times in {getTZAbbr()} (current time {current_time})
      </p>
      {mentor_info.no_sessions > 5 && mentor_info.rating > 0 && (
        <div className={styles.info_item}>
          <Star />
          <span className={styles.info_bold}>
            {mentor_info.rating.toFixed(1)}
          </span>
          <p className={styles.info_text}>
            ({roundSessionCount(mentor_info.no_sessions)} sessions)
          </p>
        </div>
      )}
      <div className={styles.info_item}>
        <Dollar />
        <span className={styles.info_bold}>${price}</span>
        <p className={styles.info_text}>
          / {duration === 30 ? "30 minute call" : "1 hour call"}
        </p>
        {mentor_info.availabilityDetails.hour &&
          mentor_info.availabilityDetails.halfHour && (
            <span className={styles.change_duration} onClick={toggleDuration}>
              {duration === 30 ? "extend to 60min" : "reduce to 30min"}
            </span>
          )}
      </div>
    </div>
  );
};

export default BookingInfo;
